import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { validateUrl } from "../api/validateUrl";
import { reqArsStatus } from "../../../modules/reducers/arsUrlValidator/checkArsStatus";
import {
  setUserChannelId,
  setEmartBranch,
  initUserChannelId,
} from "../../../modules/reducers/parseUrl";
import { initProductCheckAgree } from "../../../modules/reducers/productSearch/agreeProduct";
import { initChatbot } from "../../../modules/reducers/chat/bot/initForNobrand";
import { initQa } from "../../../modules/reducers/chat/bot/qa";
import queryString from "query-string";
import { initBranches } from "../../../modules/reducers/getBranches/getBranches";
import { initItem } from "../../../modules/reducers/lostFound/checkListedItem";
import { initFileUpload } from "../../../modules/reducers/chat/agent/fileUpload";
import ReactGA from "react-ga4";
import { initGA, setGA } from "../../../modules/reducers/ga/googleAnalitics";
import { initChatStatus } from "#src/modules/reducers/chat/agent/connectChatServer.js";
import useReactGASend from "#src/hooks/useReactGASend.js";
import { initStatus } from "#src/modules/reducers/arsUrlValidator/checkChatStatus.js";
import { initServiceAlert } from "#src/modules/reducers/serviceAlert/actions.js";
import LogRocket from 'logrocket';
const { REACT_APP_GA_TRACKING_ID, REACT_APP_MODE } = process.env;

const useCheckArsStatus = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { makeEventTrackFn } = useReactGASend();

  const status = useSelector((state) => state.checkArsStatus.status);
  const channelId = useSelector((state) => state.checkArsStatus.channelId);
  const errorType = useSelector((state) => state.checkArsStatus.errorType);

  useEffect(() => {
    dispatch(initUserChannelId());
    dispatch(initChatbot());
    dispatch(initQa());
    dispatch(initBranches());
    dispatch(initItem());
    dispatch(initFileUpload());
    dispatch(initChatStatus());
    dispatch(initGA());
    dispatch(initStatus());
    dispatch(initServiceAlert());
    const encodedSearch = location.search.replace(/\+/g, "%2B"); // queryString을 이용해 parsing 핟 때 "+"가 공백으로 치환됨으로 "+"기호 미리 변환˜
    const queryParams = queryString.parse(encodedSearch);

    if (queryParams.user_id && queryParams.chnlId) {
      const tempUserId = queryParams.user_id;
      const userId = tempUserId??"".replaceAll(" ", "+");

      const chnlId = queryParams.chnlId;

      dispatch(setUserChannelId({ userId, channelId: chnlId }));
      dispatch(setEmartBranch({ emartBranchId: null, emartBranchName: null }));
      dispatch(initProductCheckAgree());
      if (chnlId) {
        const uuid = uuidv4();
        const api = validateUrl(chnlId, uuid);
        dispatch(reqArsStatus(api));
      }
      const logRocketMode = REACT_APP_MODE === "prd" ? "ic/chatbot-prd" : "ic/chatbot";
      LogRocket.init(logRocketMode);
      LogRocket.identify(userId, {name: userId});
    }
  }, []);

  useEffect(() => {
    if (status) {
      if (status === "available") {
        navigate("/loading", { replace: true });
      } else if ((status === "expired")) {
        navigate("/expired", { replace: true });
      }
    }
  }, [status]);

  useEffect(() => {
    if (channelId) {
      ReactGA.initialize(REACT_APP_GA_TRACKING_ID);

      ReactGA.initialize(REACT_APP_GA_TRACKING_ID);
      ReactGA.ga("set", "userId", channelId);
      dispatch(setGA({ status: true }));
    }
  }, [channelId]);
};

export default useCheckArsStatus;
